/**
 * Share functionality
 * - Uses native Web Share API on mobile
 * - Falls back to Bootstrap popover with social share links on desktop
 */
$(document).ready(function() {

    // Generate share links HTML
    function generateShareLinks(shareData) {
        const encodedUrl = encodeURIComponent(shareData.url);
        const encodedTitle = encodeURIComponent(shareData.title);
        const encodedText = encodeURIComponent(shareData.text || shareData.title);

        return `
            <div class="share-links">
                <a href="https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}"
                   target="_blank" rel="noopener noreferrer" class="share-link share-link--facebook" title="Facebook">
                    <svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-facebook"></use></svg>
                </a>
                <a href="https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}"
                   target="_blank" rel="noopener noreferrer" class="share-link share-link--twitter" title="X (Twitter)">
                    <svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-twitter"></use></svg>
                </a>
                <a href="https://wa.me/?text=${encodedText}%20${encodedUrl}"
                   target="_blank" rel="noopener noreferrer" class="share-link share-link--whatsapp" title="WhatsApp">
                    <svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-whatsapp"></use></svg>
                </a>
                <a href="https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}"
                   target="_blank" rel="noopener noreferrer" class="share-link share-link--linkedin" title="LinkedIn">
                    <svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-linkedin"></use></svg>
                </a>
                <button type="button" class="share-link share-link--copy js-copy-url" data-url="${shareData.url}" title="Copiază link">
                    <svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-link"></use></svg>
                </button>
            </div>
        `;
    }

    // Show popover fallback
    function showPopover(element, shareData) {
        let popover = bootstrap.Popover.getInstance(element);

        if (!popover) {
            popover = new bootstrap.Popover(element, {
                html: true,
                sanitize: false,
                trigger: 'manual',
                placement: 'bottom',
                content: generateShareLinks(shareData)
            });
        }

        // Toggle popover
        const isShown = element.hasAttribute('aria-describedby');

        if (isShown) {
            popover.hide();
        } else {
            // Hide other popovers
            $('.js-share-btn').not(element).each(function() {
                const p = bootstrap.Popover.getInstance(this);
                if (p) p.hide();
            });
            popover.show();
        }
    }

    // Handle share button click
    $(document).on('click', '.js-share-btn', async function(event) {
        event.preventDefault();
        event.stopPropagation();

        const $shareButton = $(this);
        const element = this;
        const shareData = {
            title: $shareButton.data('share-title') || document.title,
            text: $shareButton.data('share-text') || '',
            url: $shareButton.data('share-url') || window.location.href
        };

        // Use native Web Share API if available
        if (navigator.share) {
            try {
                await navigator.share({
                    title: shareData.title,
                    text: shareData.text,
                    url: shareData.url
                });
            } catch (err) {
                // User cancelled - do nothing
                // AbortError means user closed the share dialog
                if (err.name !== 'AbortError') {
                    // Other error - fall back to popover
                    showPopover(element, shareData);
                }
            }
        } else {
            // No native share - show popover
            showPopover(element, shareData);
        }
    });

    // Close popover when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.js-share-btn, .popover').length) {
            $('.js-share-btn').each(function() {
                const popover = bootstrap.Popover.getInstance(this);
                if (popover) popover.hide();
            });
        }
    });

    // Copy URL to clipboard
    $(document).on('click', '.js-copy-url', function(event) {
        event.preventDefault();
        event.stopPropagation();

        const url = $(this).data('url');
        const $button = $(this);

        navigator.clipboard.writeText(url).then(function() {
            // Show feedback
            const originalHtml = $button.html();
            $button.html('<svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-check"></use></svg>');
            $button.addClass('share-link--copied');

            setTimeout(function() {
                $button.html(originalHtml);
                $button.removeClass('share-link--copied');
            }, 2000);
        }).catch(function(err) {
            console.error('Failed to copy URL:', err);
        });
    });
});
